<template>
    <div>
        <v-btn v-if="!nc" small text :loading="loading" @click="loadPhotos">
            {{ loadError ? "Riprova foto" : "Mostra foto" }}
        </v-btn>
        <span v-if="loadError" role="alert" class="text-caption">Foto non disponibili</span>
        <template v-if="nc">
            <altri-files v-if="nc.foto.length" :files="nc.foto" :h="40" :w="40" />
            <span v-else class="text-caption">Nessuna foto</span>
        </template>
    </div>
</template>
<script>
import AltriFiles from "../../include/AltriFiles.vue";

export default {
    name: "FilesNC",
    components: { AltriFiles },
    props: {
        deferred: { type: Boolean, default: false },
        numero: {
            type: String,
            required: true,
        },
        riga: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        nc: undefined,
        loading: false,
        loadError: false,
    }),
    mounted() {
        if (!this.deferred) this.loadPhotos();
    },
    methods: {
        async loadPhotos() {
            if (this.loading || this.nc) return;
            this.loading = true;
            this.loadError = false;
            try {
                const response = await this.$work.get(`/arts/nc/${this.numero}/${this.riga}/`);
                if (!response.data || !Array.isArray(response.data.foto)) throw new Error("Foto non disponibili");
                this.nc = response.data;
            } catch (error) {
                this.loadError = true;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
